import React from 'react';
import Loader from 'react-loader-spinner';
import common from 'constants/common';

const withLoaderTable = (loading, Component) => {
  if (loading) {
    return (
      <tbody>
        <tr>
          <td colSpan="5" style={{ width: '100%' }}>
            <Loader className="loader" type="Oval" color={common.loaderColor} />
          </td>
        </tr>
      </tbody>
    );
  }
  return Component;
};

export default withLoaderTable;
